@if (inconsistencies(); as inconsistencies) {
    @if (partnerTheme()) {
        <!-- Partner layout -->
        <div class="flex flex-col gap-4 rounded-[5px] border border-[#eeede9] bg-white p-12">
            <div
                class="malou-text-34--bold uppercase leading-[1.05] text-malou-text-title"
                [style.font-family]="partnerTheme()?.titleFont ?? null">
                {{ 'maloupe.diagnostic_result.inconsistencies.title_partner' | pluralTranslate: inconsistencies.inconsistencyCount }}
            </div>

            <div class="flex flex-col gap-[15px]">
                <!-- Inconsistency count row -->
                <div
                    class="flex items-start justify-between rounded-[5px] p-[22px]"
                    [ngClass]="{ 'bg-malou-state-error/10': inconsistencesRating() === DiagnosticRating.BAD }">
                    <div class="flex flex-col gap-1">
                        <span class="malou-text-16--semibold text-malou-text-title">
                            {{
                                'maloupe.diagnostic_result.inconsistencies.inconsistency_count'
                                    | pluralTranslate: inconsistencies.inconsistencyCount
                            }}
                            {{
                                'maloupe.diagnostic_result.inconsistencies.platform_count' | pluralTranslate: inconsistencies.platformCount
                            }}
                        </span>
                        <span class="malou-text-12--regular text-malou-text">
                            @switch (inconsistencesRating()) {
                                @case (DiagnosticRating.GOOD) {
                                    {{ 'maloupe.diagnostic_result.inconsistencies.text.good' | translate }}
                                }
                                @default {
                                    {{ 'maloupe.diagnostic_result.inconsistencies.text.bad' | translate }}
                                }
                            }
                        </span>
                        @if (platformKeysToDisplay().length > 0) {
                            <div class="flex items-center gap-2 pt-1">
                                @for (platformKey of platformKeysToDisplay(); track $index) {
                                    <img
                                        class="h-[17px] w-[17px] rounded-[3px]"
                                        [alt]="platformKey"
                                        [src]="platformKey | logoPathResolver: { folder: 'platforms' }" />
                                }
                                @if (otherPlatformCount() > 0) {
                                    <span class="malou-text-10--semibold text-malou-text">+{{ otherPlatformCount() }}</span>
                                }
                            </div>
                        }
                    </div>
                    <app-rating-chip [diagnosticRating]="inconsistencesRating()"></app-rating-chip>
                </div>

                <!-- Photos row -->
                <div
                    class="flex items-start justify-between rounded-[5px] border border-[#eeecea] bg-white p-[22px]"
                    [ngClass]="{ '!border-0 bg-malou-state-error/10': photosRating() === DiagnosticRating.BAD }">
                    <div class="flex flex-col gap-1">
                        <span class="malou-text-16--semibold text-malou-text-title">
                            {{ 'maloupe.diagnostic_result.inconsistencies.photos.title' | translate }}
                        </span>
                        <span class="malou-text-12--regular text-malou-text">
                            {{ 'maloupe.diagnostic_result.inconsistencies.photos.text' | translate }}
                        </span>
                    </div>
                    <app-rating-chip [diagnosticRating]="photosRating()"></app-rating-chip>
                </div>

                <!-- Services row -->
                <div
                    class="flex items-start justify-between rounded-[5px] border border-[#eeecea] bg-white p-[22px]"
                    [ngClass]="{ '!border-0 bg-malou-state-error/10': servicesRating() === DiagnosticRating.BAD }">
                    <div class="flex flex-col gap-1">
                        <span class="malou-text-16--semibold text-malou-text-title">
                            {{ 'maloupe.diagnostic_result.inconsistencies.services.title' | translate }}
                        </span>
                        <span class="malou-text-12--regular text-malou-text">
                            {{
                                (presentServiceCount() === serviceCount()
                                    ? 'maloupe.diagnostic_result.inconsistencies.services.text.all_present'
                                    : 'maloupe.diagnostic_result.inconsistencies.services.text.some_missing'
                                ) | translate: { serviceCount: serviceCount(), presentServiceCount: presentServiceCount() }
                            }}
                        </span>
                    </div>
                    <app-rating-chip [diagnosticRating]="servicesRating()"></app-rating-chip>
                </div>
            </div>
        </div>
    } @else {
        <!-- Default layout -->
        <div class="flex flex-col gap-4 rounded-[10px] border border-malou-primary bg-malou-white p-12 md:p-4">
            <div class="malou-text-34--bold text-color-text-title md:malou-text-20--bold font-passion-one uppercase md:leading-none">
                <span [innerHTML]="'maloupe.diagnostic_result.inconsistencies.title' | pluralTranslate: inconsistencies.inconsistencyCount">
                </span>
            </div>

            <div class="flex flex-col gap-4">
                <div
                    class="flex items-start justify-between rounded-[10px] p-6 md:p-4"
                    [ngClass]="{ 'bg-malou-state-error-light/10': inconsistencesRating() === DiagnosticRating.BAD }">
                    <div class="flex items-center">
                        <img class="h-32 md:hidden" [src]="Illustration.OK_HAND | illustrationPathResolver" />
                        <div class="flex flex-col gap-2">
                            <div class="flex justify-between gap-x-2">
                                <span class="malou-text-16--semibold md:malou-text-14--bold text-malou-text-title sm:w-9/12">
                                    {{
                                        'maloupe.diagnostic_result.inconsistencies.inconsistency_count'
                                            | pluralTranslate: inconsistencies.inconsistencyCount
                                    }}
                                    {{
                                        'maloupe.diagnostic_result.inconsistencies.platform_count'
                                            | pluralTranslate: inconsistencies.platformCount
                                    }}
                                </span>
                                <app-rating-chip class="hidden md:block" [diagnosticRating]="inconsistencesRating()"></app-rating-chip>
                            </div>
                            <div class="malou-text-12--regular flex items-center text-malou-text md:block">
                                @switch (inconsistencesRating()) {
                                    @case (DiagnosticRating.GOOD) {
                                        {{ 'maloupe.diagnostic_result.inconsistencies.text.good' | translate }}
                                    }
                                    @default {
                                        <img class="mr-1 h-3 md:float-left" [src]="Icon.WARNING | imagePathResolver: { folder: 'icons' }" />
                                        {{ 'maloupe.diagnostic_result.inconsistencies.text.bad' | translate }}
                                    }
                                }
                            </div>
                            @if (platformKeysToDisplay().length > 0) {
                                <div class="flex items-center gap-2">
                                    @for (platformKey of platformKeysToDisplay(); track $index) {
                                        <img
                                            class="h-5 w-5 rounded"
                                            [alt]="platformKey"
                                            [src]="platformKey | logoPathResolver: { folder: 'platforms' }" />
                                    }
                                    @if (otherPlatformCount() > 0) {
                                        <div class="malou-text-12--semibold text-malou-text">+{{ otherPlatformCount() }}</div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <app-rating-chip class="md:hidden" [diagnosticRating]="inconsistencesRating()"></app-rating-chip>
                </div>

                <div class="flex items-center gap-5 rounded-[10px] bg-malou-dark p-4">
                    <img class="h-8 w-8" [alt]="Icon.TRUMPET" [src]="Icon.TRUMPET | imagePathResolver" />
                    <div class="malou-text-12--bold text-malou-text">
                        {{ 'maloupe.diagnostic_result.inconsistencies.indication' | translate }}
                    </div>
                </div>

                <div
                    class="rounded-[10px] border border-malou-primary p-6 md:p-4"
                    [ngClass]="{ 'bg-malou-state-error-light/10': photosRating() === DiagnosticRating.BAD }">
                    <app-rating-bloc
                        [isInverted]="true"
                        [title]="'maloupe.diagnostic_result.inconsistencies.photos.title' | translate"
                        [text]="'maloupe.diagnostic_result.inconsistencies.photos.text' | translate"
                        [rating]="photosRating()">
                    </app-rating-bloc>
                </div>

                <div
                    class="rounded-[10px] border border-malou-primary p-6 md:p-4"
                    [ngClass]="{ 'bg-malou-state-error-light/10': servicesRating() === DiagnosticRating.BAD }">
                    <app-rating-bloc
                        [isInverted]="true"
                        [title]="'maloupe.diagnostic_result.inconsistencies.services.title' | translate"
                        [text]="
                            (presentServiceCount() === serviceCount()
                                ? 'maloupe.diagnostic_result.inconsistencies.services.text.all_present'
                                : 'maloupe.diagnostic_result.inconsistencies.services.text.some_missing'
                            ) | translate: { serviceCount: serviceCount(), presentServiceCount: presentServiceCount() }
                        "
                        [rating]="servicesRating()">
                    </app-rating-bloc>
                </div>
            </div>
        </div>
    }
}
